import React from 'react';
import { Navigate } from 'react-router-dom';
import { Spin } from 'antd';
import { useAuthContext } from '../contexts/AuthContext';
import DashboardPage from '../pages/dashboard/DashboardPage';

const DashboardRouter: React.FC = () => {
  const { isSuperAdmin, isAuthenticated, isLoading, user } = useAuthContext();

  // Show loading while auth is being initialized
  if (isLoading) {
    return null; // Let the parent ProtectedRoute handle the loading
  }

  // If not authenticated, let ProtectedRoute handle the redirect
  if (!isAuthenticated) {
    return null;
  }

  // Wait for user data to be fully loaded before making role decisions
  if (!user || !user.Staff) {
    console.log('DashboardRouter - Waiting for user data to load');
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50vh' }}>
        <Spin size="large" tip="Chargement du tableau de bord..." />
      </div>
    );
  }

  console.log('DashboardRouter - User role:', user.Staff?.role || user.profile?.role || user.staffRole);
  console.log('DashboardRouter - isSuperAdmin():', isSuperAdmin());

  // Redirect super admins to the system dashboard
  if (isSuperAdmin()) {
    console.log('DashboardRouter - Redirecting super admin to /dashboard/system');
    return <Navigate to="/dashboard/system" replace />;
  }

  console.log('DashboardRouter - Showing regular dashboard');
  // For communal admins and other users, show the regular dashboard
  return <DashboardPage />;
};

export default DashboardRouter;